import { render, staticRenderFns } from "./BaseNamePreviewFileUploadInput.vue?vue&type=template&id=5fa4a90e&scoped=true"
import script from "./BaseNamePreviewFileUploadInput.vue?vue&type=script&lang=js"
export * from "./BaseNamePreviewFileUploadInput.vue?vue&type=script&lang=js"
import style0 from "./BaseNamePreviewFileUploadInput.vue?vue&type=style&index=0&id=5fa4a90e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa4a90e",
  null
  
)

export default component.exports